<template>
  <div class="container" style="max-width: 450px;">
    <ValidationObserver v-slot="{ invalid }">
      <form ref="form" @submit.prevent="createCustomer">
       
        <validation-provider rules="required" name="name" v-slot="{ errors }">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              v-model="customer.name"
              :placeholder="$t('Customer_Name')"
            />
            <span class="error">{{ errors[0] }}</span>
          </div>
        </validation-provider>
        <validation-provider rules="email" name="email" v-slot="{ errors }">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              v-model="customer.email"
              :placeholder="$t('Email')"
            />
            <span class="error">{{ errors[0] }}</span>
          </div>
        </validation-provider>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            v-model="customer.phone"
            :placeholder="$t('phone_number')"
          />
        </div>
        <loading v-if="loading_customer"></loading>
        <button
          type="submit"
          :disabled="invalid"
          class="btn btn-default text-right"
        >
          {{ $t("Create") }} {{ $t("Customer") }}
        </button>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import store from "@/store";

export default {
  name: "BaseCustomer",
  data: () => ({
    customer: {
      phone: "",
      email: "",
      name: "",
    },
  }),
  computed: {
    loading_customer() {
      return store.getters["customer/loading"] || false;
    },
    restaurant() {
      return store.getters["restaurant/restaurant"];
    },

  },
  methods: {
    async createCustomer() {
      let data = this.customer;
      data.restaurant_id = this.restaurant.id;
      await store.dispatch("customer/create_customer", data);
      let customer = await store.getters["customer/customer"];
      if (customer.id) {
        this.$emit("saved", true);
        return this.$emit("input", customer);
      }
    },
  },
};
</script>